import { formatAuditUser } from '../../utils/userDisplay.js';
import { formatIstDateTime } from '../../utils/localDate.js';
import SettlementFieldList from './SettlementFieldList.js';

const displayName = (record, prefix, fallbackName) => {
  const label = formatAuditUser(record, prefix);
  if (label && label !== '—') return label;
  return fallbackName || '—';
};

export function settlementReviewerName(request) {
  if (!request) return '—';
  const named = displayName(
    request,
    'reviewed_by',
    request.reviewed_by_display || request.reviewed_by_name,
  );
  if (named !== '—') return named;
  if (request.status === 'APPROVED') return 'AI auto-approved';
  if (request.status === 'REJECTED') return '—';
  return 'Awaiting review';
}

export function settlementReviewerLabel(status) {
  if (status === 'REJECTED') return 'Rejected by';
  return 'Approved by';
}

/**
 * Submitted / approved / rejected audit block for settlement request modals.
 * Shown on Pending, Approved, and Rejected.
 */
export default function SettlementAuditFields({ request }) {
  if (!request) return null;

  const submittedBy = displayName(
    request,
    'submitted_by',
    request.submitted_by_display || request.submitted_by_name,
  );
  const reviewedBy = settlementReviewerName(request);
  const reviewedWhen =
    request.reviewed_at || request.status === 'APPROVED' || request.status === 'REJECTED'
      ? formatIstDateTime(request.reviewed_at)
      : '—';

  return (
    <SettlementFieldList
      items={[
        { label: 'Submitted by', value: submittedBy },
        { label: 'Submitted at', value: formatIstDateTime(request.submitted_at) },
        { label: settlementReviewerLabel(request.status), value: reviewedBy },
        {
          label: request.status === 'REJECTED' ? 'Rejected at' : 'Approved at',
          value: reviewedWhen,
        },
      ]}
    />
  );
}
